import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'forcePositiveNumber'})
export class ForcePositiveNumber implements PipeTransform {
    transform(value: any, ...args: any[]): any {
        if (+value < 0)
            return Math.abs(+value).toFixed(2);
        return  value;
    }
}
